export default "//static.tradera.net/touchweb/static/output/images/network-linkedin.a9ce5654.svg";